<template>
    <div>
        <div class="text-h2 font-weight-bold" v-html="$t('whitelabel.steps.title')"></div>
        <div class="text-h5 pt-6 grey--text" v-html="$t('whitelabel.steps.subtitle')"></div>
        <div>
            <v-card color="#E7EBF5" class="px-3 py-9 mt-9" elevation="0">
                <v-row>
                    <v-col cols="12" md="2" sm="12" class=" d-flex justify-center align-center"><div class="text-h3 pa-3 primary--color text-center" v-html="$t('whitelabel.steps.step_1.number')"></div></v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="12" md="5" sm="12" class="d-flex align-center content-center">
                        <div class="text-h6 black--text px-6" v-html="$t('whitelabel.steps.step_1.text')"></div>
                    </v-col>
                    <v-col cols="12" md="5" sm="12" class="d-flex align-center content-center">
                        <!-- <div class="px-6 py-3"> -->
                            <v-img src="@/assets/whitelabel/whitelabel-search.svg" class="px-6 mx-auto" width="100%" max-width="360" height="130" contain alt="Search"></v-img>
                        <!-- </div> -->
                    </v-col>
                </v-row>
            </v-card>
            <v-card color="#E7EBF5" class="px-3 py-9 mt-3" elevation="0">
                <v-row>
                    <v-col cols="12" md="2" sm="12" class="d-flex justify-center align-center"><div class="text-h3 pa-3 primary--color text-center" v-html="$t('whitelabel.steps.step_2.number')"></div></v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="12" md="5" sm="12" class="d-flex align-center content-center">
                        <div class="text-h6 black--text px-6" v-html="$t('whitelabel.steps.step_2.text')"></div>
                    </v-col>
                    <v-col cols="12" md="5" sm="12" class="d-flex align-center content-center">
                        <!-- <div class="px-6 py-3"> -->
                            <v-img src="@/assets/whitelabel/whitelabel-mediakit.svg" class="px-6 mt-n3" max-width="100%" height="130" contain alt="Search"></v-img>
                        <!-- </div> -->
                    </v-col>
                </v-row>
            </v-card>
            <v-card color="#E7EBF5" class="px-3 py-9 mt-3" elevation="0">
                <v-row>
                    <v-col cols="12" md="2" sm="12" class="d-flex justify-center align-center"><div class="text-h3 pa-3 primary--color text-center" v-html="$t('whitelabel.steps.step_3.number')"></div></v-col>
                    <v-divider vertical></v-divider>
                    <v-col cols="12" md="5" sm="12" class="d-flex align-center content-center">
                        <div class="text-h6 black--text  px-6" v-html="$t('whitelabel.steps.step_3.text')"></div>
                    </v-col>
                    <v-col cols="12" md="5" sm="12" class="d-flex align-center content-center">
                        <!-- <div class="px-6 py-3"> -->
                            <v-img src="@/assets/whitelabel/whitelabel-customize.svg" class="px-6 mt-n3" max-width="100%" height="130" contain alt="Search"></v-img>
                        <!-- </div> -->
                    </v-col>
                </v-row>
            </v-card>
            <v-card 
                v-if="!hasSigned" 
                class="d-flex justify-space-between white--text px-9 py-9 mt-9" 
                color="primary" 
                to="/cadastrar?isWhitelabel=1" 
                elevation="0">
                <div></div><div class="text-h5 font-weight-bold">{{ $t('whitelabel.steps.cta')}}</div><v-icon large color="white">mdi-arrow-right</v-icon>
            </v-card>
            
            <a 
                v-else 
                href="https://calendly.com/themediatrade-maggi" 
                target="_blank" 
                style="text-decoration: none;">
                <v-card class="d-flex justify-space-between white--text px-9 py-9 mt-9" color="primary" elevation="0">
                    <div></div><div class="text-h5 font-weight-bold">Solicitar uma proposta</div><v-icon large color="white">mdi-arrow-right</v-icon>
                </v-card>
            </a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'WhitelabelSteps',
  computed: {
    hasSigned() {
      return this.$route.query.signed !== undefined;
    }
  }
}
</script>